module.exports = __webpack_public_path__ + "static/media/testimonial.bc1380d8.svg";